/**
 * Fix robusto per i pulsanti + / - del carrello.
 *
 * DIAGNOSI VERIFICATA via console (utente):
 * - cart-items custom element FUNZIONA: updateQuantity e onChange
 *   sono entrambi funzioni definite.
 * - input.stepUp() chiamato direttamente cambia il valore (2->3).
 * - Quando dispatchamo input.dispatchEvent('change') dopo stepUp,
 *   pero' cart-items NON riceve il change event (test mostra che
 *   il listener change su cart-items non scatta). Il change event
 *   si perde lungo il bubble (probabilmente fermato da
 *   stopPropagation del listener Dawn rotto su <quantity-input>).
 * - cliccando direttamente il button NULLA cambia: il listener
 *   Dawn QuantityInput.onButtonClick non scatta (constructor
 *   probabilmente fallito).
 *
 * SOLUZIONE: bypassiamo completamente il bubble. Click in capture
 * phase a livello document. Calcoliamo manualmente la nuova
 * quantita'. Chiamiamo DIRETTAMENTE cartItems.updateQuantity(line,
 * quantity, event, name, variantId) — questo e' il metodo Dawn
 * gia' funzionante che fa il fetch /cart/change.js e aggiorna
 * tutte le sezioni (incluso il widget .idt-tier-widget).
 */
(function () {
  'use strict';

  window.__idtproCartQtyFix = function () {
    return 'loaded ' + new Date().toISOString();
  };

  function handleCartQuantityClick(event) {
    const button = event.target.closest('.quantity__button');
    if (!button) return;

    // Risolvi il <cart-items> o <cart-drawer-items> parent
    const cartItems = button.closest('cart-items, cart-drawer-items');
    if (!cartItems) return;

    const qInput = button.closest('quantity-input');
    if (!qInput) return;

    const input = qInput.querySelector('input[type="number"]');
    if (!input || input.disabled || input.readOnly) return;

    const action = button.getAttribute('name');
    if (action !== 'plus' && action !== 'minus') return;

    // PRENDIAMO IL CONTROLLO
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    const previousValue = parseInt(input.value, 10) || 0;
    const step = parseInt(input.step, 10) || 1;
    const min = input.min !== '' ? parseInt(input.min, 10) : 0;
    const max = input.max !== '' ? parseInt(input.max, 10) : Infinity;

    let newValue;
    if (action === 'plus') {
      newValue = previousValue + step;
      if (newValue > max) newValue = max;
    } else {
      newValue = previousValue - step;
      if (newValue < min) newValue = min;
    }

    if (newValue === previousValue) return;

    // Visual feedback immediato (verra' confermato dall'AJAX response)
    input.value = newValue;

    // Chiamata diretta al metodo Dawn cart-items.updateQuantity.
    // Bypassiamo change event bubble (che si perde) e il debounce.
    if (typeof cartItems.updateQuantity === 'function') {
      const line = input.dataset.index;
      const variantId = input.dataset.quantityVariantId;
      try {
        cartItems.updateQuantity(line, newValue, event, action, variantId);
      } catch (err) {
        console.error('[IDTPRO cart-quantity-fix] updateQuantity threw:', err);
        // Fallback: tenta il dispatchEvent change come ultimo resort
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else {
      // Fallback per cart-drawer-items o altri tipi che non hanno updateQuantity
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // CAPTURE phase a livello document: scatta su ogni click prima
  // di tutti gli altri listener, indipendentemente da clone/replace
  // del button.
  document.addEventListener('click', handleCartQuantityClick, true);
})();
